<template>
  <ul class="flex gap-2">
    <li v-for="btn in options" :key="btn.label">
      <Button
        :class="[
          (modelValue !== btn.value && 'border-gray-400 text-gray-400') ||
            'border border-solid border-hqPurple',
          'bg-white',
        ]"
        :disabled="btn.disabled"
        :text="btn.label"
        secondaryButton
        v-bind="buttonProps"
        @click="$emit('update:modelValue', btn.value)"
        @key-press="$emit('update:modelValue', btn.value)"
      />
      <input
        :id="btn.label"
        :disabled="disabled"
        :required="required"
        class="hidden"
        type="radio"
      />
    </li>
  </ul>
</template>
<script setup>
import Button from "../Button/Button.vue";

defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  buttonProps: {
    type: Object,
  },
});
defineEmits(["update:modelValue"]);
</script>
